import clsx from "clsx";
import { invoiceTypeLabel } from "@/lib/invoiceType";

const TYPE_STYLES: Record<string, string> = {
  deposit: "bg-violet-500/15 text-violet-800 dark:text-violet-300",
  final: "bg-sky-500/15 text-sky-800 dark:text-sky-300",
  full: "bg-fill-secondary text-label-secondary",
  electricity: "bg-amber-500/15 text-amber-900 dark:text-amber-200",
  credit_note: "bg-emerald-500/15 text-emerald-900 dark:text-emerald-200",
};

export interface InvoiceTypeBadgeProps {
  invoiceType: string;
  className?: string;
}

export function InvoiceTypeBadge({ invoiceType, className }: InvoiceTypeBadgeProps) {
  const key = invoiceType.toLowerCase();
  return (
    <span
      className={clsx(
        "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium",
        TYPE_STYLES[key] ?? "bg-fill-tertiary text-label-secondary",
        className,
      )}
    >
      {invoiceTypeLabel(invoiceType)}
    </span>
  );
}
